import { useQuery } from '@tanstack/react-query';
import { GlobalSetting } from 'src/models/GlobalSetting';
import { httpClient } from 'src/utils/httpClient';
import { useSuspenseQuery } from 'src/utils/useSupenseQuery';

export class GlobalSettingsRepository {
  keys = {
    all: () => ['global-settings'],
  };

  getAll = async () => {
    const { data } = await httpClient.get<GlobalSetting>(`app/global-settings`);
    return data;
  };
}

const repo = new GlobalSettingsRepository();

export const useAllGlobalSettingsQuery = () =>
  useQuery({
    queryKey: repo.keys.all(),
    queryFn: () => repo.getAll(),
  });
